export const boardReportTour = {
  key: "boardReport",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-report-filters"]',
      content: t("Tour_BoardReport_Filters"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-report-kpis"]',
      content: t("Tour_BoardReport_KPIs"),
      placement: "top",
    },
    {
      target: '[data-tour="board-report-donuts"]',
      content: t("Tour_BoardReport_Donuts"),
      placement: "top",
    },
    {
      target: '[data-tour="board-report-members"]',
      content: t("Tour_BoardReport_Members"),
      placement: "top",
    },
    {
      target: '[data-tour="board-report-sprints"]',
      content: t("Tour_BoardReport_Sprints"),
      placement: "top",
    },
    {
      target: '[data-tour="board-report-tasks"]',
      content: t("Tour_BoardReport_Tasks"),
      placement: "top",
    },
    {
      target: '[data-tour="board-report-export"]',
      content: t("Tour_BoardReport_Export"),
      placement: "bottom",
    },
  ],
};
